<script setup lang="ts">
import { AppStandardModal } from '@libs/ui';
import type { Pax } from '@libs/trip-planner-interfaces';

import type { RoomPaxConfig } from './PaxSelector.model';
import { usePaxSelectorStore } from './stores/paxSelectorStore';
import PaxSelectorView from './PaxSelectorView.vue';

interface PaxSelectorModalProps {
  initialPaxes: RoomPaxConfig[];
  shouldShowTicketsWarning: boolean;
  shouldShowRoomSelectionWarning: boolean;
  shouldShowNumberOfVehiclesUpdatedWarning: boolean;
  shouldShowNumberOfVehiclesWillBeUpdatedWarning: boolean;
}

const props = defineProps<PaxSelectorModalProps>();

interface PaxSelectorModalEmits {
  (eventName: 'confirm-modal', newPax: Pax): void;
  (eventName: 'cancel-modal'): void;
}

const emit = defineEmits<PaxSelectorModalEmits>();

const paxSelectorStore = usePaxSelectorStore();
</script>

<template>
  <AppStandardModal
    @close="emit('cancel-modal')"
    @confirm="emit('confirm-modal', paxSelectorStore.asPax)"
  >
    <template #title>
      {{ $t('planner.pax.travelers', 2) }}
    </template>
    <template #body>
      <PaxSelectorView
        :initial-paxes="props.initialPaxes"
        :should-show-tickets-warning="props.shouldShowTicketsWarning"
        :should-show-room-selection-warning="
          props.shouldShowRoomSelectionWarning
        "
        :emit-debounce-time-ms="0"
        :should-show-number-of-vehicles-updated-warning="
          props.shouldShowNumberOfVehiclesUpdatedWarning
        "
        :should-show-number-of-vehicles-will-be-updated-warning="
          props.shouldShowNumberOfVehiclesWillBeUpdatedWarning
        "
      />
    </template>

    <template #button>
      {{ $t('planner.update') }}
    </template>
  </AppStandardModal>
</template>
